import React from 'react';
import { useTranslation } from 'react-i18next';
import { Gift, Tag, Store, Sparkles, List } from 'lucide-react';

const ITEMS = [
  { key: 'all', Icon: Sparkles, color: '#1A1C19' },
  { key: 'free', Icon: Gift, color: '#7A9A78' },
  { key: 'yard_sale', Icon: Store, color: '#D99E4A' },
];

export default function FilterBar({ filter, setFilter, counts = [], listOpen, onToggleList }) {
  const { t } = useTranslation();
  const countFor = (key) => {
    if (key === 'all') return counts.length;
    return counts.filter(p => p.category === key).length;
  };
  return (
    <div className="glass-panel rounded-full px-1.5 py-1.5 sm:px-2 sm:py-2 flex items-center gap-0.5 sm:gap-1" data-testid="filter-bar">
      <button
        data-testid="list-view-toggle-btn"
        onClick={onToggleList}
        title={t('filter.list')}
        className={`flex items-center gap-1.5 sm:gap-2 rounded-full px-2.5 py-1.5 sm:px-4 sm:py-2 text-xs sm:text-sm font-medium transition ${listOpen ? 'bg-brand text-white shadow' : 'text-brand-ink hover:bg-black/5'}`}
      >
        <List className="w-3.5 h-3.5 sm:w-4 sm:h-4" style={!listOpen ? { color: '#2C5545' } : {}} />
        <span>{t('filter.list')}</span>
      </button>
      <span className="w-px h-5 sm:h-6 bg-black/10 mx-0.5" />
      {ITEMS.map(({ key, Icon, color }) => {
        const active = filter === key;
        return (
          <button
            key={key}
            data-testid={`filter-${key}-btn`}
            onClick={() => setFilter(key)}
            className={`group flex items-center gap-1.5 sm:gap-2 rounded-full px-2.5 py-1.5 sm:px-4 sm:py-2 text-xs sm:text-sm font-medium transition ${active ? 'bg-brand-ink text-white shadow' : 'text-brand-ink hover:bg-black/5'}`}
          >
            <Icon className="w-3.5 h-3.5 sm:w-4 sm:h-4" style={!active ? { color } : {}} />
            <span>{t(`filter.${key}`)}</span>
            <span className={`text-[10px] sm:text-xs ${active ? 'text-white/80' : 'text-brand-dim'}`}>{countFor(key)}</span>
          </button>
        );
      })}
    </div>
  );
}
